"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCommercePermissions = void 0;
const react_redux_1 = require("react-redux");
const Types_1 = require("Types");
const AddToCart_1 = require("../Components/UI/AddToCart/AddToCart");
const useUserData_1 = __importDefault(require("./useUserData"));
const useCommercePermissions = (type, prices, stockStatus) => {
    const userData = (0, useUserData_1.default)();
    const isNorthAmerica = (0, react_redux_1.useSelector)((state) => state.initialData.isNorthAmerica);
    // Can see price
    const canSeePrice = !isNorthAmerica || (userData.isAuthenticated && userData.axaptaProfile.canSeePricing);
    // Can see stock
    const canSeeStock = type !== Types_1.VariantTypes.MINI_CART_VIEW &&
        ((!isNorthAmerica &&
            userData.roles &&
            userData.roles.some(role => role === Types_1.UserRoles.EU_DISTRIBUTORS || role === Types_1.UserRoles.EU_SEE_LIST_PRICING)) ||
            isNorthAmerica);
    // Can see orders
    const canSeeOrders = userData.isAuthenticated &&
        userData.roles.includes(isNorthAmerica ? Types_1.UserRoles.NA_PLACE_ORDERS : Types_1.UserRoles.EU_PLACE_ORDERS) &&
        userData.hasAxaptaData;
    // Can see invoices
    const canSeeInvoices = userData.isAuthenticated &&
        userData.roles.includes(isNorthAmerica ? Types_1.UserRoles.NA_SEE_INVOICES : Types_1.UserRoles.EU_SEE_INVOICES) &&
        userData.hasAxaptaData;
    const hasOnlyRedStock = stockStatus &&
        !stockStatus.some(status => status.colorStatus === AddToCart_1.ColorStatus.Green || status.colorStatus === AddToCart_1.ColorStatus.Yellow);
    // Can make order
    let canMakeOrder = false;
    if ((!hasOnlyRedStock || type === Types_1.VariantTypes.MINI_CART_VIEW) &&
        userData.isAuthenticated &&
        userData.roles.includes(isNorthAmerica ? Types_1.UserRoles.NA_PLACE_ORDERS : Types_1.UserRoles.EU_PLACE_ORDERS) &&
        userData.hasAxaptaData) {
        if (!isNorthAmerica && ((prices && prices[0].itemPrice !== 0) || type === Types_1.VariantTypes.MINI_CART_VIEW)) {
            canMakeOrder = true;
        }
        else if (isNorthAmerica) {
            canMakeOrder = true;
        }
    }
    else {
        canMakeOrder = false;
    }
    // Should see login text
    const showLoginText = !userData.isAuthenticated ||
        (userData.roles &&
            !userData.roles.some(role => isNorthAmerica
                ? role === Types_1.UserRoles.NA_DISTRIBUTORS
                : role === Types_1.UserRoles.EU_DISTRIBUTORS || role === Types_1.UserRoles.EU_SEE_LIST_PRICING));
    return {
        canSeePrice,
        canSeeStock,
        canMakeOrder,
        canSeeInvoices,
        canSeeOrders,
        showLoginText
    };
};
exports.useCommercePermissions = useCommercePermissions;
exports.default = exports.useCommercePermissions;
